import {
  PM_CONTRACT_START,
  PM_CONTRACT_END,
  PM_CONTRACT_BY_ID,
  PM_CONTRACT_RESET,
} from '../../actions/PriceManagementContract/ActionTypes';

const initialState = {
  loading: false,
  contractDataById: {},
};

const PriceManagementContractReducer = (state = initialState, action) => {
  switch (action.type) {
    case PM_CONTRACT_BY_ID:
      return { ...state, contractDataById: action.data };
    case PM_CONTRACT_START:
      return { ...state, loading: true };
    case PM_CONTRACT_END:
      return { ...state, loading: false };
    case PM_CONTRACT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default PriceManagementContractReducer;
